export default __webpack_public_path__ + "static/novel-banner-no-coin-eb173caf88421d4c71c7e1fedcc6893b.png";